/**
 * Attribution helper for the HuddleUp SPA.
 *
 * Two trackers are loaded globally from public/index.html:
 *   • Google Analytics 4 (gtag) — id G-W379RRZY1N
 *   • LinkedIn Insight Tag — id 10522737
 *
 * Because this is a single-page app, neither tracker auto-detects route
 * changes. This module fires SPA-friendly signals:
 *   • trackPageView(path)   → GA4 page_view + LinkedIn track on every route
 *   • trackConversion(name) → GA4 event + LinkedIn virtual URL push on
 *                             diagnostic and partner-enquiry submissions
 *
 * LinkedIn Campaign Manager can match a URL-rule conversion on
 * "/diagnostic/submitted" or "/partner-enquiry/submitted". Google
 * Analytics captures the conversion as a named GA4 event.
 */

function gtagSafe() {
  if (typeof window === "undefined") return null;
  return typeof window.gtag === "function" ? window.gtag : null;
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  try {
    const location = path || window.location.pathname + window.location.search;
    const gtag = gtagSafe();
    if (gtag) {
      gtag("event", "page_view", {
        page_path: location,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    if (typeof window.lintrk === "function") {
      window.lintrk("track");
    }
  } catch {
    /* analytics should never break the UX */
  }
}

export function trackConversion(name, product) {
  if (typeof window === "undefined") return;
  try {
    const virtualPath =
      name === "partner-enquiry-submitted"
        ? "/partner-enquiry/submitted"
        : "/diagnostic/submitted";
    const suffix = product
      ? `?product=${encodeURIComponent(String(product).toLowerCase())}`
      : "";
    window.history.pushState({}, "", `${virtualPath}${suffix}`);

    const gtag = gtagSafe();
    if (gtag) {
      gtag("event", name, {
        event_category: "conversion",
        event_label: product || undefined,
        recommended_product: product || undefined,
      });
      // Also emit a virtual page_view so URL-rule conversions in any
      // analytics tool can match the /submitted path.
      gtag("event", "page_view", {
        page_path: `${virtualPath}${suffix}`,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    if (typeof window.lintrk === "function") {
      window.lintrk("track");
    }
  } catch {
    /* attribution should never break the UX */
  }
}
